import { CountryCode } from 'libphonenumber-js';

export interface PhoneNumberModel {
  phoneNumber: string;
  displayPhoneNumber?: string;
  prefix: PrefixModel;
}

export interface PrefixModel {
  code: CountryCode | 'OTHER';
  name: string;
  dialCode: string;
  displayLabel?: string;
}

// Préfixe spécial pour numéros non-standards (3615, 15, etc.)
export const OTHER_PREFIX: PrefixModel = {
  code: 'OTHER',
  name: 'Autre',
  dialCode: '',
  displayLabel: 'Autre (numéros spéciaux)',
};
